<template>
    <div class="backdrop" @click.self="onClose">
        <div class="report-modal">
            <div>
                <RangeSelector @on-view="onView" @on-close="onClose" />
            </div>
            <div style="display:flex; flex-direction: columns;justify-content:space-between;background-color: var(--con-main-theme-card-header-color-2);">
                <div class="report-title">{{reportTitle}}</div>
                <div style="display:flex; flex-direction: columns;justify-content:flex-end;background-color: #2196e2;" v-show="dataReport != null">
                    <div class="report-export" @click="savePdf">PDF</div>
                    <div class="report-export" @click="exportCsv">CSV</div>
                </div>
            </div>

            <div style="background: white; overflow-y: auto;height: 90%;" v-show="dataReport != null">
                <table class="report-div-table" cellspacing="0">
                    <tr class="report-div-table-row">
                        <th class="report-div-table-col" style="width: 16%">Date Time</th>
                        <th class="report-div-table-col" style="width: 8%">Location</th>
                        <th class="report-div-table-col" style="width: 8%">Item</th>
                        <th class="report-div-table-col" style="width: 8%;text-align:right">Price</th>
                        <th class="report-div-table-col" style="width: 10%">Status</th>
                        <!-- <th class="report-div-table-col" style="width: 10%">Card Type</th> -->
                        <th class="report-div-table-col" style="width: 10%">Card Number</th>
                        <th class="report-div-table-col" style="width: 15%">Card Holder Name</th>
                        <th class="report-div-table-col" style="width: 10%">Transaction Result</th>
                        <!-- <th class="report-div-table-col" style="width: 16%">Response Text</th> -->
                        <th class="report-div-table-col" style="width: 15%">Reference Number</th>
                        <th class="report-div-table-col" style="width: 15%">Authorization Code</th>
                        <th class="report-div-table-col" style="width: 15%">Void Status</th>
                        <th class="report-div-table-col" style="width: 15%">Void Response</th>
                        <th class="report-div-table-col" style="width: 10%">Order Id</th>
                    </tr>

                    <tr v-for="row in dataReport" :key="row.description" class="report-div-table-row">
                        <td class="report-div-table-col">{{ row.timestampDisplay }}</td>
                        <td class="report-div-table-col">{{ row.location }}</td>
                        <td class="report-div-table-col">{{ row.item }}</td>
                        <td class="report-div-table-col" style="text-align:right">{{ row.amountDisplay }}</td>
                        <td class="report-div-table-col">{{ row.status }}</td>
                        <!-- <td class="report-div-table-col">{{ row.cardType }}</td> -->
                        <td class="report-div-table-col">{{ row.cardNumber }}</td>
                        <td class="report-div-table-col">{{ row.cardHolderName }}</td>
                        <td class="report-div-table-col">{{ row.transactionResult }}</td>
                        <!-- <td class="report-div-table-col">{{ row.responseText }}</td> -->
                        <td class="report-div-table-col">{{ row.referenceNumber }}</td>
                        <td class="report-div-table-col">{{ row.authorizationCode }}</td>
                        <td class="report-div-table-col">{{ row.voidStatus }}</td>
                        <td class="report-div-table-col">{{ row.voidResponse }}</td>
                        <td class="report-div-table-col">{{ row.invoiceId }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import RangeSelector from "@/views/components/Reports/RangeSelector.vue";
import apiReport from "@/api/apiReport";
import { storage } from "@/common/storage";
import { ref } from "@vue/reactivity";
import { getCurrentInstance } from "@vue/runtime-core";
import PdfHelper from "@/common/pdfHelper";
import Helper from '@/common/helper'

export default {
    components: {
        RangeSelector
    },
    setup(props, { emit }) {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(true);
        const dataReport = ref();

        const reportTitle = ref("Credit Card Voids and Refunds");
        const reportfilename = ref("CreditCardVoidLogsRefunds");

        const onClose = () => {
            dataReport.value = null
            emit("on-close");
        };

        const onView = async () => {
            try {
                fetchingData.value = true;
                emitter.emit("server-call-start", "Loading...");

                dataReport.value = await apiReport.creditCardVoids(storage.getReportDateStart(), storage.getReportDateEnd());
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };

        const exportCsv = () => {
            var csvData = []
            dataReport.value.forEach((item) => {
                var row = {
                    Date__Time : item.timestampDisplay.toExcelSafe(),
                    Location : item.location?.toExcelSafe(),
                    Item : item.item?.toExcelSafe(),
                    Price : item.amount,
                    Status : item.status?.toExcelSafe(),
                    Card__Type : item.cardType?.toExcelSafe(),
                    Card__Number : item.cardNumber?.toExcelSafe(),
                    Card__Holder__Name : item.cardHolderName?.toExcelSafe(),
                    Transaction__Result : item.transactionResult?.toExcelSafe(),
                    Response__Text : item.responseText?.toExcelSafe(),
                    Reference__Number : item.referenceNumber?.toExcelSafe(),
                    Authorization__Code : item.authorizationCode?.toExcelSafe(),
                    Void__Status : item.voidStatus?.toExcelSafe(),
                    Void__Response : item.voidResponse?.toExcelSafe(),
                    Order__Id : item.invoiceId?.toExcelSafe(),
                };                
                csvData.push(row);
            });
            Helper.exportCsv(csvData, reportfilename.value);            
        };        

        const savePdf = () => {
            var positions = {
                xField1: 12,
                pField1: "left",

                xField2: 45,
                pField2: "left",

                xField3: 65,
                pField3: "left",

                xField4: 91,
                pField4: "right",

                xField5: 95,
                pField5: "left",

                xField6: 110,
                pField6: "left",

                xField7: 127,
                pField7: "left",

                xField8: 152,
                pField8: "left",

                xField9: 180,
                pField9: "left",

                xField10: 202,
                pField10: "left",

                xField11: 218,
                pField11: "left",

                xField12: 240,
                pField12: "left",

                xField13: 260,
                pField13: "left",
            };

            var pdfData = [];
            dataReport.value.forEach((item) => {
                var row = {
                    Date__Time : item.timestampDisplay,
                    Location : item.location,
                    Item : item.item,
                    Price : item.amountDisplay,
                    Status : item.status,
                    // Card__Type : item.cardType,
                    Card__Number : item.cardNumber,
                    Card__Holder__Name : item.cardHolderName,
                    Transaction__Result : item.transactionResult,
                    // Response__Text : item.responseText,
                    Reference__Number : item.referenceNumber,
                    Authorization__Code : item.authorizationCode,
                    Void__Status : item.voidStatus,
                    Void__Response : item.voidResponse,
                    Order__Id : item.invoiceId,
                };
                pdfData.push(row);
            });

            var pdfHeler = new PdfHelper();
            pdfHeler.savePdf(pdfData, positions, reportTitle.value, reportfilename.value, storage.getReportDateStart(), storage.getReportDateEnd(), "landscape", -4);
        };

        

        return {
            reportTitle,

            dataReport,
            onClose,
            onView,

            savePdf,
            exportCsv
        };
    }
};
</script>

<style scoped>
.report-modal {
    width: 90%;
    height: 80%;
    margin: 100px auto;
    background: white;
    /* border-radius: 10px; */
}
</style>
